<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      パスワード再設定
    </Header>
    <div class="my-5 mx-4">
      <p class="mb-4 text-weight-500 text-center text-weight-600">
        ご登録された電話番号宛(SMS)に、<br />
        再設定用の認証コードが送信されます
      </p>
      <AppButton block rounded @click="nextStep">
        認証コードを送信する
      </AppButton>
    </div>
  </div>
</template>

<script lang="ts">
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import TextFieldWithIconGroup from "@/components/molecules/form/TextFieldWithIconGroup.vue";
import { authStore } from "@/store/auth";
import { Component, Vue } from "vue-facing-decorator";

@Component({
  components: {
    AppButton,
    FeatherIcon,
    Header,
    TextFieldWithIconGroup
  }
})
export default class ResetPasswordAfterLogin extends Vue {
  phoneNumber = "";

  created() {
    const workerPhoneNumber = authStore.user?.workerPhoneNumber;
    if (workerPhoneNumber) {
      this.phoneNumber = workerPhoneNumber;
    }
  }

  async nextStep() {
    try {
      await this.$router.push({ name: "ResetPasswordAccountAuth" });
    } catch {
      await this.$bvModal.msgBoxOk("不正な操作です", {
        centered: true
      });
    }
  }
}
</script>
